module.exports = __webpack_public_path__ + "static/media/planoComunicacao.bf7e346a.md";